<template>
  <div v-if="started || finished.length > 0 || currentlyReading"
       class="summary reading-summary">
    <h2>Reading</h2>
    <div v-if="currentlyReading">
      <h3>Currently</h3>
      <img class="pull-left book-cover" :src="currentlyReading.cover.path">
      <div class="pull-left book-title">
        <a :href="currentlyReading.link">{{ currentlyReading.title }}</a>
        by {{ currentlyReading.author }}
      </div>
      <div style="clear: both"></div>
    </div>
    <div v-else-if="started">
      <h3>Started</h3>
      <img class="pull-left book-cover" :src="started.cover.path">
      <div class="pull-left book-title">
        <a :href="started.link">{{ started.title }}</a>
        by {{ started.author }}
      </div>
      <div style="clear: both"></div>
    </div>

    <div v-if="finished.length > 1">
      <h3>Finished</h3>
      <img class="pull-left book-cover"
           v-for="(details, index) in finished"
           :key="index"
           :src="details.read.cover.path"
           @load="$redrawVueMasonry()">
      <div class="pull-left book-titles">
        <span v-for="(details, index) in finished" :key="index">
          <a :href="details.read.link">
            {{ details.read.title }}
          </a>
          by <span>{{ details.read.author }}</span>
          <template v-if="index !== finished.length - 1">, </template>
        </span>
      </div>
      <div style="clear: both"></div>
    </div>
    <div v-if="finished.length == 1">
      <h3>Finished</h3>
      <img class="pull-left book-cover" :src="finished[0].read.cover.path">
      <div class="pull-left book-title">
        <a :href="finished[0].read.link">{{ finished[0].read.title }}</a>
        by {{ finished[0].read.author }}
      </div>
      <div style="clear: both"></div>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
.pull-left
  float left

.book-title
  display block
  padding-left 10px
  width: 50%

.book-titles
  display block
  padding-top 10px
  width: 100%

.book-cover
  display block
  width 25%
</style>

<script>
import { getLastEventByFeed, parseOccurred } from '@/eventlog'

export default {
  name: 'Reading',
  inject: ['getEvents', 'isCurrent'],
  components: {},
  data() {
    return {
      started: null,
      finished: [],
      currentlyReading: null
    }
  },
  async created() {
    const events = await this.getEvents

    const books = {}

    for (const event of events) {

      if (
        event.feed.short_name === 'goodreads' ||
        event.feed.short_name === 'hardcover'
      ) {

        const book = this.eventToBook(event)

        if (! books[book.title]) {
            books[book.title] = {
                state: book.state,
                details: {
                    [book.state]: book
                }
            }
        } else {
            books[book.title].state = book.state
            books[book.title].details[book.state] = book
        }
      }
    }

    for (const title in books) {
        if (books[title].state == 'currently-reading') {
            const book = books[title].details['currently-reading']

            if (this.isCurrent) {
                this.currentlyReading = book
            } else {
                this.started = book
            }
        } else {
            this.finished.push(books[title].details)
        }
    }

    if (this.isCurrent && ! this.currentlyReading) {

        const [lastGoodreadsEvent, lastHardcoverEvent] = await Promise.all([
          getLastEventByFeed('goodreads'),
          getLastEventByFeed('hardcover'),
        ]);

        const lastGoodreads = parseOccurred(lastGoodreadsEvent.occurred)
        const lastHardcover = parseOccurred(lastHardcoverEvent.occurred)

        var event = lastHardcoverEvent
        if (lastGoodreads > lastHardcover) {
          event = lastGoodreadsEvent
        }

        const book = this.eventToBook(event)

        if (book.state == 'currently-reading') {
            this.currentlyReading = book
        }
    }
  },
  methods: {
    eventToBook(e) {
      if (e.feed.short_name === 'goodreads') {
        return {
          title: e.title,
          author: e.raw.author_name,
          cover: e.original,
          state: e.text,
          link: e.link
        }
      } else if (e.feed.short_name === 'hardcover') {
        return this.hardcoverEventToBook(e)
      }
    },
    hardcoverEventToBook(e) {
      const authors = [];

      for (const contribution of e.raw.data.userBook.edition.contributions) {
        authors.push(contribution.author.name)
      }

      return {
        title: e.title,
        author: authors.join(' & '),
        cover: e.original,
        state: e.text,
        link: e.link
      }
    }
  }
}
</script>